module.exports = __webpack_public_path__ + "static/media/5eadc61ecd11463a67744b0f_Telegram 2.c010ebd5.svg";